export const ROUTES = {
  HOME: "/",
  PROFILE: "/profile",
  BENEFITS: "/benefits",
  OFFERINGS: "/offerings",
  UNAUTHORIZED_PAGE: "/unauthorized",
  DASHBOARD: "/dashboard",
  WALLET: "/wallet",
  EMPLOYER: "/employer",
};
